module.exports = __webpack_public_path__ + "img/ThreeAxleTractorThreeAxleSemitrailer.37205839.svg";